import { render, staticRenderFns } from "./SizeSpec.vue?vue&type=template&id=0d3f58de&"
import script from "./SizeSpec.vue?vue&type=script&lang=js&"
export * from "./SizeSpec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports